import { render, staticRenderFns } from "./app-discrepancy-list.vue?vue&type=template&id=dc289b6c&scoped=true&"
import script from "./js/app-discrepancy-list.js?vue&type=script&lang=js&"
export * from "./js/app-discrepancy-list.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc289b6c",
  null
  
)

export default component.exports